import MuiSwitch from '@mui/material/Switch';

import { SWITCH_LABEL_GAP_PX } from 'theme/components/switch';
import ControlLabel from 'ui/control-label';
import type { SwitchProps } from 'ui/switch/switch.types';

const Switch = ({
  label,
  size = 'medium',
  disabled,
  sx,
  ref,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
  ...rest
}: SwitchProps) => {
  const inputProps = {
    ref,
    'aria-label': ariaLabel,
    'data-testid': dataTestId,
  };
  const control = (
    <MuiSwitch
      {...rest}
      size={size}
      disabled={disabled}
      sx={label === undefined ? sx : undefined}
      slotProps={{ input: inputProps }}
    />
  );

  if (label === undefined) {
    return control;
  }

  return (
    <ControlLabel
      control={control}
      label={label}
      size={size}
      disabled={disabled}
      gap={SWITCH_LABEL_GAP_PX}
      sx={sx}
    />
  );
};

export default Switch;
